import { Divider, Stack } from '@mui/material';

import Footer from './Footer';
import Header from './Header';
import PollQuestion from './PollQuestion';
import { Content, pollPageClasses } from './styles';
import usePollPage from './vm';

const PollPage = () => {
  const {
    pollTitleFormMethods,
    onSubmitPollTitle,
    onLocalSubmitPollTitle,
    pollQuestionFormMethods,
    onSubmitPollQuestion,
    onLocalSubmitPollQuestion,
    errors,
    handleValidateForms,
  } = usePollPage();

  return (
    <Stack gap={4} px={4} py={2} height="100%">
      <Header
        formMethods={pollTitleFormMethods}
        onSubmit={onSubmitPollTitle}
        onLocalSubmit={onLocalSubmitPollTitle}
        triggerValidations={handleValidateForms}
        errors={errors}
      />
      <Divider />
      <Content flex={1} color="common.black">
        <PollQuestion
          formMethods={pollQuestionFormMethods}
          onSubmit={onSubmitPollQuestion}
          onLocalSubmit={onLocalSubmitPollQuestion}
          className={pollPageClasses.questionForm}
        />
        <Footer triggerValidations={handleValidateForms} errors={errors} />
      </Content>
    </Stack>
  );
};

export default PollPage;
